/**
 * 사전
 */
import { useMemo, Fragment } from 'react';
import { GAME_NAME, SERVER_TYPE, SERVICE_ALIAS } from '@constants/service';
import { SEARCH_PARAMS } from '@constants/router';
import type { IDictionary, ISetDictionary, l10nType } from '@type/index';

interface IDictionaryParams {
  item: IDictionary;
  l10n: l10nType;
  searchParams: URLSearchParams;
  option: IOption;
}

export const setDictionaryItem = ({ item, l10n, searchParams, option }: IDictionaryParams): ISetDictionary | null => {
  if (!item || typeof item !== 'object') {
    return null;
  }

  const keyword = searchParams?.get(SEARCH_PARAMS.KEYWORD);
  const isServerAden = item?.server === SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2;
  const folderName = isServerAden ? GAME_NAME[SERVICE_ALIAS.LINEAGE2].L2 : GAME_NAME[SERVICE_ALIAS.LINEAGE2].L2AWKN;
  const service = item?.service.toLocaleLowerCase();
  const { lineage2GradeNameMap, lineage2AwakeningGradeNameMap } = option;
  const crystalTypeNameMap = isServerAden ? lineage2GradeNameMap : lineage2AwakeningGradeNameMap;

  return item && typeof item === 'object'
    ? {
        ...item,
        serverName: item?.server === SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2 ? l10n.filter.l2Server : l10n.filter.l2AwknServer,
        serviceName: item?.service === 'item' ? l10n.filter.itemDictionary : l10n.filter.skillDictionary,
        url: `/dic/${folderName}/${service}/?${service}id=${item?.id}&query=${keyword}`,
        crystalTypeName: item?.crystalType && crystalTypeNameMap ? crystalTypeNameMap[item.crystalType] : '',
      }
    : null;
};

const DictionaryArticle = ({ item, l10n, searchParams, option }: IDictionaryParams) => {
  const data = setDictionaryItem({ item, l10n, searchParams, option });

  if (!data) {
    return <Fragment />;
  }

  const { url, image, name, nameClass, additionalName, server, service, level, itemTypeName, crystalTypeName, iconTypeName } = data;
  const isAden = useMemo(() => server === SERVER_TYPE[SERVICE_ALIAS.LINEAGE2].L2, [server]);
  const isSkill = useMemo(() => service === 'skill', [service]);

  return (
    <div className="search-item-content">
      <div className="search-item-thumbnail">
        <a href={url}>{image ? <img src={image} alt="" /> : <Fragment />}</a>
      </div>
      <div className="search-item-article">
        <div className={`search-item-title rare-${nameClass}`}>
          <a href={url}>
            <span dangerouslySetInnerHTML={{ __html: name }}></span>
            {additionalName ? <span className="addition">{additionalName}</span> : <Fragment />}
            {isSkill ? (
              <span className="addition">
                Lv {level} {l10n?.template?.getSkill}
              </span>
            ) : (
              <Fragment />
            )}
          </a>
        </div>
        <div className="search-item-info">
          <span>{isAden ? l10n?.filter?.l2Server : l10n?.filter?.l2AwknServer}</span>
          <span>{isSkill ? l10n?.filter?.skillDictionary : l10n?.filter?.itemDictionary}</span>
          {itemTypeName ? <span>{itemTypeName}</span> : <Fragment />}
          {crystalTypeName ? <span>{crystalTypeName}</span> : <Fragment />}
          {iconTypeName ? <span>{iconTypeName}</span> : <Fragment />}
        </div>
      </div>
    </div>
  );
};

export default DictionaryArticle;
